import { FC } from 'react';
import { ErrorLayout } from '@shared/layouts/ErrorLayout';
import { UNKNOWN_ERROR } from '@shared/libs/errors-consts';

export const FormErrorLayout: FC = () => {
  return <ErrorLayout error={UNKNOWN_ERROR} showBasicButton={true} navigateTo={() => globalThis.location.reload()} />;
};
